import _ from 'lodash'

export function getUrlVars() {
    let vars = [],
        hash,
        hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');

    _.each(hashes, (hashElement) => {
        hash = hashElement.split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    })

    return vars;
};
export function getUrlVar(name) {
    return getUrlVars()[name];
};

// не используется
export function getIsFullWidthDiff(editedWidth, editedHeight, realWidth, realHeight) {
    let diffW = 1;
    let diffH = 1;
    diffW = realWidth / editedWidth
    diffH = realHeight / editedHeight
    return { diffW, diffH }
}

// не используется
export function convertPositions(caption, diffW, diffH, realHeight, realWidth) {
    caption.position.x *= diffW
    caption.position.y *= diffH
    if (caption.boxId != '') {
        caption.position.relativeX *= diffW
        caption.position.relativeY *= diffH
    }
    if (caption.position.y + caption.fontSize + caption.padding * 2 + caption.borderWidth * 2 + caption.fontSize / 4 > realHeight) {
        caption.position.y = realHeight - caption.fontSize - caption.padding * 2 - caption.borderWidth * 2 - caption.fontSize / 4
    }
    if (caption.position.x + caption.padding * 2 + caption.borderWidth * 2 > realWidth) {
        caption.position.x -= caption.padding * 2 + caption.borderWidth * 2
    }
    return caption
}

// не используется
export function convertDimension(caption, diffW, diffH, prevFontSize, actualFontSize) {
    let fontSizeDiff = actualFontSize / prevFontSize
    if (caption.width != undefined && caption.height != undefined) {
        if(caption.type === 'text'){
            caption.width += 5
        }
        
        caption.width *= diffW
        if (caption.type === 'text' || caption.type === 'button') {
            caption.height *= fontSizeDiff
        } else {
            // перенёс расчёт высоты боксов и шейпов в else, иначе высота текста получала перерасчёт и за себя и за того парня 
            caption.height *= diffH
        }
    }
    return caption
}

export function convertBoxPointPosition(pointsArray, diffW, diffH) {
    // let maxDiff =
    pointsArray.map(point => {
        point.x *= diffW
        point.y *= diffH
    })
    return pointsArray
}

// не используется
export function convertStyle(captionStyle, middleDiff, diffW) {
    // console.log('captionStyle1',captionStyle);
    captionStyle.fontSize *= diffW
    // captionStyle.lineHeight *= diffW
    captionStyle.borderWidth *= middleDiff
    captionStyle.padding *= middleDiff

    // // конвертирую параметры тени
    captionStyle.shadow.distance *= diffW
    captionStyle.shadow.blur *= diffW
    captionStyle.shadow.size *= diffW
    captionStyle.shadow.x *= diffW
    captionStyle.shadow.y *= diffW

    if(typeof captionStyle.borderRadius === 'number'){
        captionStyle.borderRadius *= middleDiff
    }else{
        captionStyle.borderRadius.leftTop *= middleDiff
        captionStyle.borderRadius.rightTop *= middleDiff
        captionStyle.borderRadius.leftBottom *= middleDiff
        captionStyle.borderRadius.rightBottom *= middleDiff
    }
    // console.log('captionStyle2',captionStyle);
    return captionStyle
}

// конвертиция тени слайда
export function convertSlideShadow(slide, middleDiff, diffW, diffH) {
    // console.log('conv slide 1',slide);
    slide.backgroundShadow.distance *= middleDiff
    slide.backgroundShadow.blur *= middleDiff
    slide.backgroundShadow.size *= middleDiff
    slide.backgroundShadow.x *= diffW
    slide.backgroundShadow.y *= diffH
    // console.log('conv slide 2',slide);
    return slide
}

// не используется
export function fullWidthConverter(slides, editedWidth, editedHeight, realWidth, realHeight) {
    const { diffW, diffH } = getIsFullWidthDiff(editedWidth, editedHeight, realWidth, realHeight)
    let middleDiff = diffW > diffH ? diffW : diffH

    if (diffW != 1 || diffH != 1) {
        slides.map(slide => {
            slide = convertSlideShadow(slide, middleDiff, diffW, diffH)
            slide.captions.map(caption => {
                const prevFontSize = caption.fontSize
                caption = convertStyle(caption, middleDiff, diffW)
                caption = convertPositions(caption, diffW, diffH, realHeight, realWidth)
                caption = convertDimension(caption, diffW, diffH, prevFontSize, caption.fontSize)
                // if (caption.type === 'box') {
                //     caption.pointsArray = convertBoxPointPosition(caption.pointsArray, diffW, diffH)
                // }
            })
        })
    }



    return slides
}


export function convertParallaxImage(parallaxParams, editedWidth, editedHeight, realWidth, realHeight, isMobile) {
    const parallaxImage = _.cloneDeep(parallaxParams)
    // const { diffW, diffH } = getIsFullWidthDiff(editedWidth, editedHeight, realWidth, realHeight)
    // const minDiff = diffW > diffH ? diffH : diffW;
    // parallaxImage.offsetX *= minDiff
    // parallaxImage.offsetY *= minDiff
    const offset = isMobile 
        ? {x: parallaxImage.mobileOffsetX, y: parallaxImage.mobileOffsetY, scale: parallaxImage.mobileScale} 
        : {x: parallaxImage.offsetX, y: parallaxImage.offsetY, scale: parallaxImage.scale}
    // console.log('send',offset,
    // parallaxImage.width, 
    // parallaxImage.height, 
    // editedWidth,
    // editedHeight,
    // realWidth, 
    // realHeight,
    // )
    const {deltaY, additionalProp, deltaX} = getImgResizedDelta(
        offset,
        parallaxImage.width, 
        parallaxImage.height, 
        editedWidth,
        editedHeight,
        realWidth, 
        realHeight,
    )
    if (isMobile) {
        parallaxImage.mobileOffsetX = Math.round(parallaxImage.mobileOffsetX + deltaX || 0)
        parallaxImage.mobileOffsetY = Math.round(parallaxImage.mobileOffsetY + deltaY || 0)
        parallaxImage.mobileScale = parallaxImage.mobileScale * additionalProp
    } else {
        parallaxImage.offsetX = Math.round(parallaxImage.offsetX + deltaX || 0)
        parallaxImage.offsetY = Math.round(parallaxImage.offsetY + deltaY || 0)
        parallaxImage.scale = parallaxImage.scale * additionalProp
    }
    // console.log('parallaxImage inside',parallaxImage)

    return parallaxImage
}

export function getHeight(settings, deviceType) {
    let height = window.innerHeight
    const hasDots = settings.hasDots;
    const dotsType = settings.dotsType;
    if (hasDots && dotsType === 'outer' && deviceType === 'desktop') {
        height = height - 15 - settings.dotsSize
    }
    return height
}

// получаем отклонения в размерых которые нужно добавить к позиции картинки, если размер виджета изменён
export const getImgResizedDelta = (offset, originWidth, originHeight, originalWidgetWidth, originalWidgetHeight, newSectionWidth, newSectionHeight) => {

    const scale = offset.scale * 100 || 100
    // оригинальные размеры изображения
    const imgHeight = originHeight
    const imgWidth = originWidth
    // на случай, если в знаменателе 0, ставим значение по умолчанию 1
    const imgOwnRatio = imgHeight / imgWidth || 1
    // текущая ширина картинки в данных размераж виджета
    const imgCurrentWidth = newSectionWidth * scale /100
    // текущая высота картинки в пикселях
    const imgCurrenHeight = imgCurrentWidth * imgOwnRatio

    // изначальная ширина картинки в размераж виджета при редактировании
    const imgEditedWidth = originalWidgetWidth * scale /100 
    // изначальная высота картинки в размераж виджета при редактировании
    const imgEditedHeight = imgEditedWidth * imgOwnRatio

    const additionalProp = newSectionHeight / imgCurrenHeight
    const posX = offset.x
    const posY = offset.y
    
    // 0% - 100% - иначе белые полосы по бокам
    const maxDiff = imgEditedWidth - originalWidgetWidth
    let percentOffsetWidth = maxDiff ? -posX * 100 / maxDiff : 0

    let useAdditionalProportion = 1
    let useDeltaX = 0
    let useDeltaY = 0
    // переводим отклонение в пиксели
    useDeltaX = -((imgCurrentWidth - newSectionWidth) / 100) * percentOffsetWidth - posX
    // находим координаты центра отредактированной картинки
    const centerEditedPointY = originalWidgetHeight / 2 - posY
    // точка на изображении, на которую центрируемся
    const editedImgCenterRatioY = (centerEditedPointY * 100) / imgEditedHeight

    // находим на каком расстоянии по оси Y на текущем размере картинки должен быть расположен визуальный центр картинки
    const neededImgCenterPosY = editedImgCenterRatioY * imgCurrenHeight / 100
    // определяем текущий центр картинки
    const centerCurrentPointY = newSectionHeight / 2 - posY
    useDeltaY = -(neededImgCenterPosY - centerCurrentPointY)
    
    let topCorrect = false
    let bottomCorrect = false
    // если картинка опустилась
    if ((useDeltaY + posY) > 0) {
        useDeltaY = - posY
        topCorrect = true
    }
    // если картинка поднялась
    if ((imgCurrenHeight - newSectionHeight + useDeltaY + posY) < 0) {
        useDeltaY = newSectionHeight - imgCurrenHeight - posY
        bottomCorrect = true
        if ((useDeltaY + posY) > 0) {
            topCorrect = true
        }
    }
    if (topCorrect && bottomCorrect) {
        // -posY - значит позиционируем, чтобы верхние края изображения и виджета совпадали
        useDeltaY = -posY
        // изображение растягивается, если есть свободное место
        useAdditionalProportion = additionalProp

        const centerEditedPointX = originalWidgetWidth / 2 - posX
        // точка на изображении, на которую центрируемся
        const editedImgCenterRatioX = (centerEditedPointX * 100) / imgEditedWidth
        // находим на каком расстоянии по оси X на текущем размере картинки должен быть расположен визуальный центр картинки
        const neededImgCenterPosX = editedImgCenterRatioX * imgCurrentWidth * useAdditionalProportion / 100
        // определяем текущий центр картинки
        const centerCurrentPointX = newSectionWidth / 2 - posX 
        useDeltaX = -(neededImgCenterPosX - centerCurrentPointX)

    }
    
    return {deltaY: useDeltaY, additionalProp: useAdditionalProportion, deltaX: useDeltaX}
}